<template>
  <div class="distributor-box">
    <!--tab栏-->
    <Tabs v-model="pageParams.statusList" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in statusDataList.filter((ele) => {return ele.value !=='2'})" :label="(h)=>labelRander(h, item)" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000689')" prop="ymsSpus">
              <Input type="textarea" :placeholder="$t('key1005767')" v-model.trim="pageParams.ymsSpus"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005768')" prop="cnName">
              <Input :placeholder="$t('key1001100')" v-model.trim="pageParams.cnName"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005769')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :options="dateOptions"
                :value="registerTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005770')" prop="updatedBys">
              <Select v-model="pageParams.updatedBys" filterable multiple>
                <Option v-for="item in updatedByList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search" :disabled="tableLoading">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box" v-if="pageParams.statusList === '1'">
      <div class="flex align-items-center">
        <div class="flex align-items-center font-size-12">
          {{ $t('key1004517') }} <span class="distributorThemeColor">{{ total }}</span> {{ $t('key1005771') }} <span class="distributorThemeColor">{{ totalMinute }}</span> {{ $t('key1005772') }}
        </div>
        <Button class="ml15" @click="stopGeneratingSalesMaterialsBtn('all')">{{ $t('key1005773') }}</Button>
      </div>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        class="distributor-page-box"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getUserNameByUserId, amountHandel, commonCopyContent, getAllUsersInfo} from "@/utils/common";

export default {
  name: "generateSalesRecords",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        cnName: '',
        createProductSalesTimeEnd: null,
        createProductSalesTimeStart: null,
        statusList: 'null', // 1 就绪 2 生成中 3 成功 4 失败
        ymsSpus: '',
        updatedBys: [], // 发起人
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      statusDataList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), total: 0},
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005753'), total: 0},
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005754'), total: 0},
        {value: '3', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005755'), total: 0},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005756'), total: 0},
      ],
      labelRander: (h, params) => {
        let total = params.total || 0;
        return h('div', {class: 'flex align-items-center'}, [
          h('span', params.title),
          h('span', `(${total})`),
        ]);
      },
      registerTime: [],
      tableColumns: [],
      tableData: [],
      selectTableData: [],
      totalMinute: 0,
      updatedByList: [],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  beforeDestroy() {
    this._isDestroyed = true;
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.updatedByList = [];
      this.setDefaultTimerParams('last_month');
      (async () => {
        await this.initWebSocket();
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
          if (data) {
            for (let key in data) {
              this.updatedByList.push({
                userId: data[key].userId,
                userName: data[key].userName
              });
            }
          }
        });
        await this.search();
      })();
    },
    /**
     * 注册售卖资料生成结果使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `generate-sales-records-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data && data.type === 'sale') {
          v.pageParamsStatus = true;
        }
      }, v);
    },

    /**
     * 清理售卖资料生成结果监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.registerTime = [];
      v.resetDate();
      v.setDefaultTimerParams('last_month');
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      if (v.pageParams.statusList === 'null') {
        params.statusList = [];
      } else if (v.pageParams.statusList === '1') {
        params.statusList = [1, 2];
      } else {
        params.statusList = [Number(v.pageParams.statusList)];
      }
      for (let key in params) {
        if (['ymsSpus'].includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.handleColumns();
      v.optionBtnWidth = [];
      v.getQuerySalesLogTotal();
      if (v.getPermission('productSalesLog_querySalesLog')) {
        v.tableLoading = true;
        v.axios.post(api.post_productSalesLog_querySalesLog, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let newData = data.list || [];
            v.tableData = newData;
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置生成时间
    resetDate() {
      this.pageParams.createProductSalesTimeStart = null;
      this.pageParams.createProductSalesTimeEnd = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createProductSalesTimeStart = null;
          v.pageParams.createProductSalesTimeEnd = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          v.pageParams.createProductSalesTimeStart = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createProductSalesTimeEnd = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data || [];
    },
    // 获取在不同的状态下的总数
    getQuerySalesLogTotal() {
      let v = this;
      v.axios.get(api.get_productSalesLog_queryCount).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.totalMinute = data.totalMinute || 0;
            let obj = {
              'null': data.totalCount,
              '4': data.failCount,
              '3': data.successCount,
              '1': data.prepareCount + data.processingCount
            };
            v.statusDataList.map((ele) => {
              ele.total = obj[ele.value] || 0;
            });
            v.$forceUpdate();
          }
        }
      });
    },
    // 处理列表Columns字段
    handleColumns() {
      let v = this;
      let status = v.pageParams.statusList;
      let hideKeyList = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let list = [
              v.tableImg(h, params, 'primaryImage'),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  },
                  on: {
                    AlinkBtn: () => {
                      v.toShopDetails(params.row.ymsProductId);
                    }
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689') + ymsSpu),
                  h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    style: {
                      marginLeft: '10px',
                      cursor: 'pointer'
                    },
                    attrs: {
                      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                    },
                    on: {
                      click: () => {
                        commonCopyContent(ymsSpu, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'));
                      }
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          renderHeader(h) {
            return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697') + '(' + v.currencyState + ')');
          },
          key: 'price',
          minWidth: 130,
          render(h, params) {
            let minSuggestPrice = amountHandel(params.row.minSuggestPrice);
            let maxSuggestPrice = amountHandel(params.row.maxSuggestPrice);
            let price = '';
            if (minSuggestPrice === maxSuggestPrice) {
              price = maxSuggestPrice;
            } else {
              price = minSuggestPrice + '~' + maxSuggestPrice;
            }
            return h('div', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005757'),
          key: 'status',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let saleLogStatus = params.row.saleLogStatus;
            let text = '-';
            v.statusDataList.map((item) => {
              let value = Number(item.value);
              if (value === saleLogStatus) {
                text = saleLogStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005758') : item.title;
              }
            });
            return h('p', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005698'),
          key: 'shelvedTime',
          align: 'left',
          minWidth: 180,
          sortable: true,
          render(h, params) {
            let shelvedTime = v.$uDate.dealTime(params.row.shelvedTime, 'fulltime');
            return h('p', shelvedTime);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005699'),
          key: 'subscriptionTime',
          align: 'left',
          minWidth: 180,
          sortable: true,
          render(h, params) {
            let subscriptionTime = v.$uDate.dealTime(params.row.subscriptionTime, 'fulltime');
            return h('p', subscriptionTime);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005759'),
          key: 'createProductSalesTime',
          align: 'left',
          minWidth: 180,
          sortable: true,
          render(h, params) {
            let createProductSalesTime = v.$uDate.dealTime(params.row.createProductSalesTime, 'fulltime');
            return h('p', createProductSalesTime);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005760'),
          key: 'errorDesc',
          align: 'left',
          minWidth: 130,
          render(h, params) {
            let text = params.row.errorDesc || '-';
            return h('p', {class: 'mt6 mb6'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005761'),
          key: 'updatedBy',
          minWidth: 140,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          fixed: 'right',
          align: 'center',
          key: 'options',
          width: 120,
          render(h, params) {
            let productSalesLogId = params.row.productSalesLogId;
            let saleLogStatus = params.row.saleLogStatus;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005762'),
                    show: saleLogStatus === 1,
                    clickFn: () => {
                      v.stopGeneratingSalesMaterialsBtn('single', productSalesLogId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      // 1 就绪 2 生成中 3 成功 4 失败
      switch (status) {
        case '3':
          hideKeyList = ['status', 'errorDesc', 'options'];
          break;
        case '4':
          hideKeyList = ['status', 'options'];
          break;
        case '1':
          hideKeyList = ['shelvedTime', 'errorDesc'];
          break;
      }
      v.tableColumns = columns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.$forceUpdate();
    },
    // 批量停止生成售卖资料
    stopGeneratingSalesMaterialsBtn(type, productSalesLogId) {
      let v = this;
      let productSalesLogIds = [];
      // 批量
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          let talg = v.selectTableData.every((item) => {
            return item.saleLogStatus === 1;
          });
          if (talg) {
            productSalesLogIds = v.selectTableData.map((item) => {
              return item.productSalesLogId;
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005763'));
            return false;
          }
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005764'));
          return false;
        }
      }
      // 点击单个
      else if (type === 'single') {
        productSalesLogIds = [productSalesLogId];
      }
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005765'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005766'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005762'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.post(api.post_productSalesLog_stopProduct, productSalesLogIds).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>
